import { createAction, props } from '@ngrx/store';

export const meRetrieve = createAction('[AUTH] Me retrieve', props<{ token: string }>());
export const meSuccess = createAction('[AUTH] Me Success', props<{ user: any }>());
export const meFailure = createAction('[AUTH] Me Failure', props<{ error: any }>());

export const accountRetrieve = createAction('[AUTH] Account retrieve');
export const accountSuccess = createAction('[AUTH] Account Success', props<{ account: any }>());
export const accountFailure = createAction('[AUTH] Account Failure', props<{ error: string }>());

export const setActiveBusiness = createAction('[AUTH] Set Active Business', props<{ businessId: string, businessType: string }>());
export const updateUser = createAction('[AUTH] Update user', props<{ user: any }>());
export const clear = createAction('[AUTH] Clear');
